import theme from "../styles/Theme";

import { StyleProject, StyleProjectTitle, StyleContentsArea, StyleContentsLeft, StyleContentsRight, StyleContentsTitle, StyleContents, StyleContent, StyleProjectImage, StyleImages, StyleImage, StyleLookBack } from "../styles/StyleProjects"

import { StyleBadgeGreen } from '../styles/StyleCommon'

import Global1 from "../images/project/global1.jpeg"
import Global2 from "../images/project/global2.jpeg"
import Global3 from "../images/project/global3.jpeg"
import Global4 from "../images/project/global4.jpeg"

const BungaeCare = () => {
    return (
        <div>
            <StyleProject>
                <StyleContentsArea theme={theme}>
                    <StyleContentsLeft>
                        <blockquote>
                            <StyleProjectTitle>2024.10 - 2025.10</StyleProjectTitle>
                            <StyleProjectTitle>글로벌 번개장터 고도화</StyleProjectTitle>
                            <StyleBadgeGreen>spring boot 3.4.x</StyleBadgeGreen>
                            <StyleBadgeGreen>kotlin 2.2.x</StyleBadgeGreen>
                            <StyleBadgeGreen>mysql 8.x</StyleBadgeGreen>
                            <StyleBadgeGreen>jpa</StyleBadgeGreen>
                            <StyleBadgeGreen>elasticsearch</StyleBadgeGreen>
                            <StyleBadgeGreen>kinesis</StyleBadgeGreen>
                        </blockquote>
                    </StyleContentsLeft>
                    <StyleContentsRight>
                        <StyleContentsTitle>본격적인 글로벌 서비스 고도화</StyleContentsTitle>
                        <StyleContents>
                            <StyleContent>검색 및 상세 화면 API 고도화 및 크고 작은 개선을 통해 서비스 전반의 사용자 경험 및 시스템 안정성 향상</StyleContent>
                            <StyleContent>글로벌 meta(facebook) 피드 연동, 환율 관리, DK(Delivered Korea) 연계 시스템 등 글로벌 핵심 인프라 및 서비스 개발</StyleContent>
                            <StyleContent>신규 글로벌 회원 체계에 따른 장바구니, 최근 본 상품, 주문 등 기능 고도화 및 이메일 발송 시스템 개발</StyleContent>
                            <StyleContent>분산 스케줄러를 활용한 환율 캐시 자동 갱신으로 멀티 인스턴스 환경에서의 중복 갱신 방지</StyleContent>
                        </StyleContents>
                        <StyleContentsTitle>글로벌 서비스의 핵심, 번역</StyleContentsTitle>
                        <StyleContents>
                            <StyleContent>상품 번역 처리와 검색/상세 화면 내 번역 정보 제공 API 개발, LLM을 활용한 번역 시스템 내재화로 외부 번역 API 의존 제거</StyleContent>
                            <StyleContent>비동기 번역 호출과 타임아웃 폴백 설계로 번역 실패 시에도 서비스 안정성 확보</StyleContent>
                            <StyleContent>번역 시스템 배포 후 구글 유입 세션수 +807%, 평균 클릭수 +793%, 평균 노출수 +3724% 등 SEO 트래픽 지표 대폭 개선</StyleContent>
                            <StyleContent>상품 탐색 및 구매 클릭수 증가(PDP/PV +200.7%, 구매 클릭 +116.3%)를 통해 유저 인게이지먼트 향상</StyleContent>
                        </StyleContents>
                        <StyleContentsTitle>글로벌 쿠폰 시스템</StyleContentsTitle>
                        <StyleContents>
                            <StyleContent>캠페인-코드풀-발급-사용-이력의 생애주기를 설계하고, 다단계 검증 체인으로 복잡한 발급/사용 규칙을 선언적으로 관리</StyleContent>
                            <StyleContent>가입 후 24시간 이내 전용 쿠폰, 기간 한정 마케팅 쿠폰 등 다양한 캠페인 유형을 통해 신규 유입과 구매 전환에 기여</StyleContent>
                            <StyleContent>주문 취소 시 쿠폰 재사용 처리, 주문 시스템 간 교차 검증 등 안정적인 쿠폰 운영으로 7%의 높은 사용률 기록</StyleContent>
                        </StyleContents>
                        <StyleContentsTitle>기술과 함께 빠르게 성장하는 서비스</StyleContentsTitle>
                        <StyleContents>
                            <StyleContent>고도화 전 대비 글로벌 번장 거래액 3.4배, 수수료 매출 4.3배, MAU 1.8배 성장 등 글로벌 사업의 핵심 성과 창출</StyleContent>
                            <StyleContent>두 차례의 글로벌 번장 x DK 프로모션을 통해 결제 건수와 결제 금액이 각각 70%, 53% 이상 증가하며 매출 증대에 기여</StyleContent>
                            <StyleContent>글로벌 번장 웹 서비스 고도화를 통해 활성 사용자의 평균 체류 시간 73% 향상</StyleContent>
                        </StyleContents>
                        <StyleImages>
                            <StyleImage theme={theme} src={Global4} title="글로벌4" alt="" />
                            <StyleImage theme={theme} src={Global3} title="글로벌3" alt="" />
                            <StyleImage theme={theme} src={Global2} title="글로벌2" alt="" />
                            <StyleImage theme={theme} src={Global1} title="글로벌1" alt="" />
                        </StyleImages>
                    </StyleContentsRight>
                </StyleContentsArea>
            </StyleProject>
        </div>
    )
}

export default BungaeCare
